import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { FiAlertTriangle } from "react-icons/fi";
import restaurant from "../../Images/Resized/Dinning/Dinning Hall (4).jpg"
import { BASEAPIURL, token } from '../../env';
import BarDetail from './BarDetail';

export default function Location() {
    const navigate = useNavigate();
    const [showBardetail,setShowBardetail] =useState(false)

    // State for locations data
    const [locations, setLocations] = useState([]);
    // Loading state
    const [loading, setLoading] = useState(true);
    // Error state
    const [error, setError] = useState(null);

    // Modal states
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    // Data for editing and deleting
    const [selectedLocation, setSelectedLocation] = useState(null);

    // Fetch locations on mount
    useEffect(() => {
        const fetchLocations = async () => {
            setLoading(true);
            setError(null);
            try {
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");

                const raw = JSON.stringify({
                    tokenData: token
                });

                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow",
                };

                const response = await fetch(
                    `${BASEAPIURL}/LocationList`,
                    requestOptions
                );

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const resultText = await response.text();
                const result = JSON.parse(resultText);

                let locationsArray = [];

                if (Array.isArray(result.data)) {
                    locationsArray = result.data;
                } else if (Array.isArray(result.locations)) {
                    locationsArray = result.locations;
                } else {
                    for (const key in result) {
                        if (Array.isArray(result[key])) {
                            locationsArray = result[key];
                            break;
                        }
                    }
                }

                setLocations(locationsArray);
            } catch (err) {
                setError(err.message || "Something went wrong");
            } finally {
                setLoading(false);
            }
        };

        fetchLocations();
    }, []);

    // Handlers to open modals
    const handleShowAdd = () => setShowAddModal(true);
    const handleCloseAdd = () => setShowAddModal(false);

    const handleShowEdit = () => setShowEditModal(true);
    const handleCloseEdit = () => {
        setShowEditModal(false);
        setSelectedLocation(null);
    };

    const handleShowDelete = () => setShowDeleteModal(true);
    const handleCloseDelete = () => {
        setShowDeleteModal(false);
        setSelectedLocation(null);
    };

    // Open edit modal with selected item
    const openEditModal = (item) => {
        setSelectedLocation(item);
        handleShowEdit();
    };

    // Open delete modal with selected item
    const openDeleteModal = (item) => {
        setSelectedLocation(item);
        handleShowDelete();
    };

    // Edit form state
    const [editFormData, setEditFormData] = useState({
        LocID: '',
        LocName: '',
        LocCategory: '0',
        ImageBase64: '',
    });

    // When selectedLocation changes, update form data
    useEffect(() => {
        if (selectedLocation) {
            setEditFormData({
                LocID: selectedLocation.LocID || '',
                LocName: selectedLocation.LocName || '',
                LocCategory: selectedLocation.LocCategory || '',
                ImageBase64: selectedLocation.ImageBase64 || '',
            });
        }
    }, [selectedLocation]);

    // Handle form input changes
    const handleEditInputChange = (e) => {
        const { name, value } = e.target;
        setEditFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    // Handle image file change for edit form
    const handleEditFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setEditFormData(prev => ({
                    ...prev,
                    ImageBase64: reader.result, // base64 string
                }));
            };
            reader.readAsDataURL(file);
        }
    };

    // Handle submit edit form (example)
    const handleEditSubmit = async (e) => {
        e.preventDefault();
        console.log("Submitting edited data:", editFormData);

        try {
            // 1. Update location info first
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                tokenData: token,
                Loc: {
                    LocName: editFormData.LocName,
                    LocCategory: editFormData.LocCategory
                }
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            await fetch(`${BASEAPIURL}/UpdateLocation?MainID=${editFormData.LocID}`, requestOptions)
                .then((res) => res.text())
                .then((result) => console.log("Location updated:", result));

            // 2. Upload image if it exists
            if (editFormData.ImageBase64) {
                const blob = await fetch(editFormData.ImageBase64).then(res => res.blob());
                const fileName = "location_image.jpg"; // or derive from context

                const formdata = new FormData();
                formdata.append("token", token);
                formdata.append("locname", editFormData.LocName);
                formdata.append("fileUpload", blob, fileName);

                await fetch(`${BASEAPIURL}/UploadLocationPhoto`, {
                    method: "POST",
                    body: formdata,
                    redirect: "follow"
                })
                    .then(res => res.text())
                    .then(result => console.log("Image uploaded:", result));
            }

            // Final cleanup
            handleCloseEdit();
        } catch (error) {
            console.error("Error during edit or image upload:", error);
            // Optionally notify user
        }
    };


    const [LocName, setLocName] = useState('');
    const [LocCategory, setLocCategory] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditFormData((prevData) => ({
            ...prevData,
            [name]: name === 'LocCategory' ? Number(value) : value
        }));
    };



    const handleInsertSubmit = (e) => {
        e.preventDefault();

        const raw = JSON.stringify({
            tokenData: token,
            Loc: {
                LocName,
                LocCategory: Number(LocCategory) // ensure it's a number
            }
        });

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        fetch("https://cluborder.eterp/InsertLocation", requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log("Insert Success:", result);
                alert("Location inserted successfully!");
                // Optionally clear form or trigger a refresh
                setLocName('');
                setLocCategory('');
            })
            .catch(error => {
                console.error("Insert Error:", error);
                alert("Failed to insert location.");
            });
    };




    return (
        <div>
            <div className='scroll-box'>
                {showBardetail ?<BarDetail setShowBardetail={setShowBardetail}/>:<div className='container mt-3'>
                    <div className='row d-flex justify-content-between align-items-center mb-2 g-0 py-2' style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        {/* <div
                            onClick={handleShowAdd}
                            className='col-2 d-flex justify-content-center align-items-center p-2 rounded-1'
                            style={{ backgroundColor: "#000", fontWeight: 400, color: "#fff", cursor: "pointer" }}
                        >
                            +Add
                        </div> */}
                    </div>

                    {loading ? (
                        <div className="text-center" style={{ fontSize: 18, fontWeight: 500 }}>
                            Loading locations...
                        </div>
                    ) : error ? (
                        <div className="text-center text-danger" style={{ fontSize: 16 }}>
                            Error: {error}
                        </div>
                    ) : (
                        <div className='row mb-3'>
                            {locations.length === 0 ? (
                                <div className="text-center" style={{ fontSize: 16, fontWeight: 500 }}>
                                    No locations found.
                                </div>
                            ) : (
                                locations.map((item, index) => {
                                    const bgImage = item.ImageBase64 || restaurant;
                                    const title = item.LocName || item.LocationName || "Unnamed Location";

                                    return (
                                        <div className='col-lg-4 col-md-6 col-sm-12 mb-4' key={index}>
                                            <div
                                                className='card text-white position-relative overflow-hidden'
                                                style={{
                                                    backgroundImage: `url(${bgImage})`,
                                                    backgroundSize: "cover",
                                                    backgroundPosition: "center",
                                                    height: "200px",
                                                    borderRadius: '10px',
                                                    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                                                }}
                                            >
                                                {/* Optional dark overlay */}
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 0,
                                                        right: 0,
                                                        bottom: 0,
                                                        backgroundColor: "rgba(0, 0, 0, 0.4)",
                                                        zIndex: 1,
                                                    }}
                                                />

                                                {/* Card Content */}
                                                <div
                                                    className="position-relative d-flex flex-column justify-content-between h-100 p-3"
                                                    style={{ zIndex: 2 }}
                                                >
                                                    <div className="d-flex justify-content-end">
                                                        <FaEdit
                                                            onClick={() => openEditModal(item)}
                                                            style={{ color: "#03a9f5", fontSize: "1.2em", cursor: "pointer", marginRight: '10px' }}
                                                        />
                                                        {/* <MdDelete
                                                            onClick={() => openDeleteModal(item)}
                                                            style={{ color: "crimson", fontSize: "1.3em", cursor: "pointer" }}
                                                        /> */}
                                                    </div>
                                                    <div
                                                        className="text-center"
                                                        onClick={() => setShowBardetail(true)}
                                                        style={{
                                                            fontSize: "18px",
                                                            fontWeight: 600,
                                                            color: "#fff",
                                                            cursor: "pointer",
                                                            textShadow: "1px 1px 3px rgba(0,0,0,0.8)"
                                                        }}
                                                    >
                                                        {title}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    );
                                })
                            )}
                        </div>
                    )}

                    {/* Add Modal (can be implemented as needed) */}
                    <Modal show={showAddModal} onHide={handleCloseAdd} size="lg">
                        <Modal.Header closeButton>
                            <Modal.Title>Add Location</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {/* Add location form here */}
                            <form onSubmit={handleInsertSubmit}>
                                <div className="mb-3">
                                    <label className="form-label">Location Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="LocName"
                                        value={LocName}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Category</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="LocCategory"
                                        value={LocCategory}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <button type="submit" className="btn btn-success">Insert</button>
                            </form>
                        </Modal.Body>
                    </Modal>

                    {/* Edit Modal */}
                    <Modal show={showEditModal} onHide={handleCloseEdit} size="lg">
                        <Modal.Header closeButton>
                            <Modal.Title>Edit Location</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <form onSubmit={handleEditSubmit}>
                                {/* <div className="mb-3">
                                    <label className="form-label">Location ID</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="LocID"
                                        value={editFormData.LocID}
                                        readOnly
                                    />
                                </div> */}
                                <div className="mb-3">
                                    <label className="form-label">Location Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="LocName"
                                        value={editFormData.LocName}
                                        onChange={handleEditInputChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Category</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="LocCategory"
                                        value={editFormData.LocCategory !== null && editFormData.LocCategory !== undefined ? String(editFormData.LocCategory) : ''}
                                        onChange={handleChange}
                                        required
                                    />


                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Image</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        accept="image/*"
                                        onChange={handleEditFileChange}
                                    />
                                </div>
                                {editFormData.ImageBase64 && (
                                    <div className="mb-3 text-center">
                                        <img
                                            src={editFormData.ImageBase64}
                                            alt="Preview"
                                            style={{ maxHeight: '150px', maxWidth: '100%', objectFit: 'contain' }}
                                        />
                                    </div>
                                )}
                                <button type="submit" className="btn btn-primary">
                                    Save Changes
                                </button>
                            </form>
                        </Modal.Body>
                    </Modal>
                </div>}
            </div>

            {/* Delete Confirmation Modal */}
            <Modal size="sm" show={showDeleteModal} onHide={handleCloseDelete}>
                <Modal.Header closeButton>
                    <Modal.Title><FiAlertTriangle style={{ color: "orangered" }} /></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center" style={{ fontSize: "16px", color: '#1f5156', fontWeight: 500 }}>
                        Are you sure you want to delete "{selectedLocation?.LocName || selectedLocation?.LocationName}"?
                    </div>
                    <div className='d-flex justify-content-between mt-3'>
                        <button
                            onClick={() => {
                                // TODO: Add your delete API call here using selectedLocation.LocID
                                console.log("Delete location with ID:", selectedLocation?.LocID);
                                handleCloseDelete();
                            }}
                            className='btn btn-danger w-100 me-2'
                        >
                            Yes
                        </button>
                        <button onClick={handleCloseDelete} className='btn btn-secondary w-100'>
                            No
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}
